import { AdacRadioButton } from '@adac-de/component-library';
import React, { forwardRef } from 'react';
import { clsx } from 'clsx';
import styles from './radio-button.module.scss';
import { withTracking } from '@utils/tracking/tracking';

type RadioButtonProps = {
  value: string;
  checked: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
  label?: string;
};

export const RadioButtonComponent = forwardRef(
  (
    { value, checked, onChange, className, label, ...rest }: RadioButtonProps,
    ref: React.Ref<HTMLInputElement>
  ) => (
    <AdacRadioButton
      value={value}
      label={label}
      ref={ref}
      name={value}
      onChange={onChange}
      className={clsx({
        [styles.radioButton]: true,
        [styles.checked]: checked,
        ...(className && {
          [className]: true
        })
      })}
      {...rest}
    />
  )
);

export const RadioButton = withTracking(RadioButtonComponent);
